export default __webpack_public_path__ + "static/media/neural_network.4d55a97f.png";